/* eslint-disable no-console */

export default function validateBirtdate(day: string, month: string, year: string): boolean {

  //Purpose
  //The form already does some validation before data get handed over to this function
  //Numbers only
  //Day > 0 and <= 31
  //Month > 0 and <= 12
  //Year > 0 and <= current year

  //but there is no check if a user enters for example 31.06.1988. The date is not valid, because June has only 30 days
  //this function checks for those issues

  let isDateCorrect = false;

  if(day !== '' && month !== '' && year != '') {

    //all data have been entered --> check if the combination is a valid date

    //parse strings to int
    const dayInt = parseInt(day);
    const monthInt = parseInt(month);
    const yearInt = parseInt(year);

    switch (monthInt) {
      case 1:
      case 3:
      case 5:
      case 7:
      case 8:
      case 10:
      case 12:

        //months with 31 days --> day is valid in any case
        isDateCorrect = true;

        break;

      case 2: {

          //special case february. Might be a leap year. Day may be invalid --> check

          const isLeapYear = new Date(yearInt, 1, 29).getDate() === 29;

          if (isLeapYear) {

            if(dayInt < 30) {
              isDateCorrect = true;
            }

          } else {

              if(dayInt < 29) {
                isDateCorrect = true;
              }
          }
        }

        break;

      case 4:
      case 6:
      case 9:
      case 11:

        //months with only 30 days. Day may be invalid --> check

        if(dayInt < 31) {
          isDateCorrect = true;
        }

        break;

      default:
        break;
    }

    return isDateCorrect;

  } else {

    //we do not yet have all date pieces and can therefore not check for a valid date.
    //we return true to not trigger the error message

    return true;
  }
}
